import HomeView from "./views/HomeView";

function App() {
  return <HomeView />;
}

export default App;
